const get = (entity) => {
  return fetch(`https://mouvyourbaudet-4f0fe.firebaseio.com/${entity}.json`)
    .then((response)=> response.json())
}

export const getPerformances = () => get('performances')

export const getVideos = () => get('videos')

export const getFriends = () => get('friends')



/** WEBPACK FOOTER **
 ** ./src/services/firebaseServices.js
 **/